import { Helmet } from "react-helmet";
import React, { Component } from "react";
import "../../styles/depots/depots.scss";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import { Button } from "react-bootstrap";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { utcToLocal } from "../../utils/dateConvert";

class DepotDetails extends Component {

  constructor(props) {
    super(props);
    this.state = {
      depotDetails: {},
    };
  }

  async componentDidMount() {
    let depotId = this.props.match.params.id;
    this.props.setLoadingPageAction(true);

    try {
      let depotDetails = await axios.get(
        `${apiHost}/api/Depots/SelectDepot/${depotId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({ depotDetails: depotDetails.data });
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }

  handleSubmit = () => {
    this.props.history.push(`/editDepot/${this.state.depotDetails.id}`);
  };

  formatValue = (value) => value || "-";

  formatDate = (value) => value ? utcToLocal(value) : "-";

  getOverlaySummary = (mapOverlay) => {
    if (!mapOverlay) {
      return "No overlay recorded";
    }

    try {
      const overlay = JSON.parse(mapOverlay);
      return overlay.type ? `${overlay.type} overlay` : "Custom overlay";
    } catch (e) {
      return "Custom overlay";
    }
  };

  render() {
    const { depotDetails } = this.state;

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Depot Details </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper depot-record-page">
              <div className="depot-record-header">
                <div>
                  <p className="depot-record-kicker">Depot record</p>
                  <h2>{this.formatValue(depotDetails.name)}</h2>
                  <p>{this.formatValue(depotDetails.customerName)}</p>
                </div>
                <div className="depot-record-actions">
                  <Button
                    variant="light"
                    onClick={() => { this.props.history.goBack(); }}
                  >
                    Back
                  </Button>
                  <Button
                    variant="primary"
                    onClick={this.handleSubmit.bind(this)}
                  >
                    Edit depot
                  </Button>
                </div>
              </div>

              <div className="depot-record-card">
                <div className="depot-detail-grid">
                  <div className="depot-detail-item">
                    <span>Name</span>
                    <strong>{this.formatValue(depotDetails.name)}</strong>
                  </div>
                  <div className="depot-detail-item">
                    <span>Description</span>
                    <strong>{this.formatValue(depotDetails.description)}</strong>
                  </div>
                  <div className="depot-detail-item">
                    <span>Customer</span>
                    <strong>{this.formatValue(depotDetails.customerName)}</strong>
                  </div>
                  <div className="depot-detail-item">
                    <span>Time zone</span>
                    <strong>{this.formatValue(depotDetails.timeZoneCity || depotDetails.timeZonesId)}</strong>
                  </div>
                  <div className="depot-detail-item">
                    <span>Created</span>
                    <strong>{this.formatDate(depotDetails.dbCreated)}</strong>
                  </div>
                  <div className="depot-detail-item">
                    <span>Updated</span>
                    <strong>{this.formatDate(depotDetails.dbUpdated)}</strong>
                  </div>
                  <div className="depot-detail-item">
                    <span>Status</span>
                    <strong><span className="depot-status-pill">Active</span></strong>
                  </div>
                  <div className="depot-detail-item">
                    <span>Overlay</span>
                    <strong>{this.getOverlaySummary(depotDetails.mapOverlay)}</strong>
                  </div>
                </div>
              </div>

              <div className="depot-record-card depot-overlay-card">
                <div>
                  <p className="depot-record-kicker">Map overlay</p>
                  <h3>{this.getOverlaySummary(depotDetails.mapOverlay)}</h3>
                </div>
                <pre className="depot-overlay-code">
                  {this.formatValue(depotDetails.mapOverlay)}
                </pre>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(DepotDetails);
